export function AdminHomePage() {
  return (
    <section className="admin-page">
      <div className="admin-page__body">
        <h2>Главная</h2>
      </div>
    </section>
  );
}
